export enum UBXContainerType {
    Default = 'default',
    Inner = 'inner',
    Outer = 'outer',
    Full = 'full',
}
